import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "Creación"
 * @REL_ATTR: "INIT"
 * @id: 5602
 * code: "INIT"
 * description: "Creada"
 * zdescripcion_web: "Creada"
 */
export default class AccessType extends BaseModel {
  constructor(opts = {}) {
    super(opts);

    this.code = opts.code;
    this.webDescription = opts.zdescripcion_web;
  }
}
